import { motion } from "framer-motion";
import { Lock } from "lucide-react";

const previewRows = [
  ["68%", "18%"],
  ["54%", "14%"],
  ["76%", "16%"],
  ["47%", "12%"],
  ["61%", "15%"],
  ["42%", "11%"],
  ["58%", "13%"],
];

const smallCards = [
  {
    tag: "02 / DÉCISIONS",
    title: "Comprends chaque position.",
    text: "Prix d'entrée, thèse, ce qui me ferait vendre, et chaque achat et vente avec sa raison. Positions clôturées comprises.",
  },
  {
    tag: "03 / ANALYSES",
    title: "Suis mes analyses en continu.",
    text: "Mes lectures des marchés, mes analyses de l'actualité et un bilan chaque mois.",
  },
  {
    tag: "04 / ESPACE PRIVÉ",
    title: "Échange en direct.",
    text: "Pose tes questions sur mes positions et échange avec les autres membres.",
  },
];

export default function PortfolioContent() {
  return (
    <section id="contenu" data-testid="pf-contenu" className="py-24 md:py-32 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="mb-14"
        >
          <span className="micro-label">Contenu</span>
          <h2 className="font-display text-4xl sm:text-5xl leading-[1.05] mt-6">
            Ce que tu <span className="italic text-[#FF6B00]">reçois</span>.
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7 }}
          className="bg-white/[0.02] border border-white/10 p-8 md:p-10 rounded-sm"
          data-testid="pf-contenu-portefeuille"
        >
          <span className="font-mono text-[10px] tracking-[0.3em] text-[#FF6B00]">01 / LE PORTEFEUILLE</span>
          <h3 className="font-display text-2xl md:text-3xl text-[#F5F5F0] mt-4">
            Vois où j'investis réellement mon argent.
          </h3>
          <p className="mt-3 !text-[15px] text-[#A3B8B0] font-light max-w-[65ch]">
            Toutes mes positions en cours, classées selon leur poids dans mon portefeuille.
          </p>

          <div className="relative mt-8 border border-white/10 rounded-sm overflow-hidden" data-testid="pf-portefeuille-preview">
            <div className="px-6 py-3 border-b border-white/10">
              <span className="font-mono text-[10px] tracking-[0.3em] text-[#758D85]">APERÇU DU PORTEFEUILLE</span>
            </div>
            <div className="p-6 md:p-8 space-y-4 select-none" aria-hidden="true">
              {previewRows.map(([left, right], i) => (
                <div key={i} className="flex items-center justify-between gap-6">
                  <div className="h-2.5 rounded-full bg-white/10 blur-[2px]" style={{ width: left }} />
                  <div className="h-2 rounded-full bg-white/10 blur-[2px] shrink-0" style={{ width: right }} />
                </div>
              ))}
            </div>
            <div className="absolute inset-0 flex items-center justify-center bg-[#111111]/40">
              <a
                href="#tarif"
                data-testid="pf-preview-unlock"
                className="group flex flex-col items-center gap-3 px-10 py-6 cursor-pointer"
              >
                <Lock
                  size={22}
                  strokeWidth={1.5}
                  className="text-[#F2F0EB] transition-transform duration-300 group-hover:scale-110"
                />
                <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#FF6B00] group-hover:underline underline-offset-4">
                  Déverrouiller l'accès →
                </span>
              </a>
            </div>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
          {smallCards.map((c, i) => (
            <motion.div
              key={c.tag}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.12 }}
              data-testid={`pf-contenu-card-${i}`}
              className="bg-white/[0.02] border border-white/10 p-8 rounded-sm transition-[background-color,border-color] duration-300 hover:bg-white/[0.04] hover:border-[#D92D20]/40"
            >
              <span className="font-mono text-[10px] tracking-[0.3em] text-[#FF6B00]">{c.tag}</span>
              <h3 className="font-display text-xl text-[#F5F5F0] mt-4">{c.title}</h3>
              <p className="mt-3 !text-[15px] text-[#A3B8B0] font-light">{c.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
